/*
 * Copyright The OpenTelemetry Authors
 * SPDX-License-Identifier: Apache-2.0
 */

export function getStringFromEnv(_: string): string | undefined {
  return undefined;
}

export function getBooleanFromEnv(_: string): boolean | undefined {
  return undefined;
}

export function getNumberFromEnv(_: string): number | undefined {
  return undefined;
}

export function getStringListFromEnv(_: string): string[] | undefined {
  return undefined;
}
